import React, { useState, useEffect } from 'react';
import { useAuth } from '../Login/AuthContext';

const Profile = () => {
  const { user, loading: authLoading, updateUserProfile } = useAuth();
  const [formData, setFormData] = useState({
    name: 'Utilisateur inconnu',
    email: '',
    bio: 'Ajoutez une bio...',
    company: 'Non spécifiée',
  });
  const [editMode, setEditMode] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!authLoading && user) {
      setFormData({
        name: user.name || 'Utilisateur inconnu',
        email: user.email || '',
        bio: user.bio || 'Ajoutez une bio...',
        company: user.company || 'Non spécifiée',
      });
      setLoading(false);
    } else if (!authLoading) {
      setLoading(false);
    }
  }, [user, authLoading]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await updateUserProfile(formData);
      setEditMode(false);
      alert('Profil mis à jour avec succès !');
    } catch (error) {
      alert('Erreur lors de la mise à jour du profil.');
    }
  };

  if (authLoading || loading) {
    return <div className="loading">Chargement...</div>;
  }

  if (!user) {
    return <div className="not-connected">Veuillez vous connecter pour voir votre profil.</div>;
  }

  return (
    <div className="profile-container">
      <h1>Mon Profil</h1>
      <div className="profile-card">
        <div className="profile-header">
          <div className="profile-picture">
            <img
              src={user.profilePicture || 'https://via.placeholder.com/150'}
              alt="Profile"
            />
          </div>
          {editMode ? (
            <form onSubmit={handleSubmit} className="profile-form">
              <div className="form-group">
                <label>Nom</label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  className="form-control"
                />
              </div>
              <div className="form-group">
                <label>Email</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  className="form-control"
                  disabled
                />
              </div>
              <div className="form-group">
                <label>Entreprise</label>
                <input
                  type="text"
                  name="company"
                  value={formData.company}
                  onChange={handleChange}
                  className="form-control"
                />
              </div>
              <div className="form-group">
                <label>Bio</label>
                <textarea
                  name="bio"
                  value={formData.bio}
                  onChange={handleChange}
                  className="form-control"
                />
              </div>
              <div className="form-actions">
                <button type="submit" className="btn btn-primary">
                  Enregistrer
                </button>
                <button
                  type="button"
                  onClick={() => setEditMode(false)}
                  className="btn btn-secondary"
                >
                  Annuler
                </button>
              </div>
            </form>
          ) : (
            <div className="profile-display">
              <h2>{formData.name}</h2>
              <p>{formData.email}</p>
              <p>{formData.company}</p>
              <p>{formData.bio}</p>
              <button
                onClick={() => setEditMode(true)}
                className="btn btn-edit"
              >
                Modifier
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Profile;
